import React, { Component } from 'react';

export default class TextIcon extends React.Component {
  render() {
    return (
      <svg
        width="55"
        height="49"
        viewBox="0 0 55 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.9917 26.5652C21.6408 26.5652 21.2603 26.5311 20.8501 26.4627C20.44 26.3943 20.0868 26.285 19.7905 26.1346C19.4989 25.9842 19.353 25.7951 19.353 25.5672C19.353 25.4852 19.3849 25.369 19.4487 25.2186C19.5125 25.0682 19.59 24.936 19.6812 24.8221C19.7769 24.7036 19.868 24.6443 19.9546 24.6443C20.0093 24.6443 20.1141 24.6831 20.2691 24.7606C20.4878 24.8699 20.7088 24.9611 20.9321 25.034C21.16 25.1024 21.4198 25.1365 21.7114 25.1365C22.076 25.1365 22.3677 25.034 22.5864 24.8289C22.8052 24.6193 22.9146 24.3276 22.9146 23.9539C22.9146 23.5438 22.8029 23.2361 22.5796 23.0311C22.3563 22.8214 21.994 22.7166 21.4927 22.7166H21.1509C21.0233 22.7166 20.9299 22.6688 20.8706 22.5731C20.8159 22.4774 20.7886 22.3247 20.7886 22.1151V21.8895C20.7886 21.6798 20.8159 21.5272 20.8706 21.4315C20.9299 21.3312 21.0233 21.2811 21.1509 21.2811H21.3833C21.7707 21.2811 22.076 21.1899 22.2993 21.0076C22.5226 20.8253 22.6343 20.5815 22.6343 20.2762C22.6343 19.9708 22.55 19.7316 22.3814 19.5584C22.2173 19.3807 21.9758 19.2918 21.6568 19.2918C21.3833 19.2918 21.16 19.3192 20.9868 19.3738C20.8137 19.424 20.6428 19.4901 20.4741 19.5721C20.424 19.5994 20.3762 19.6222 20.3306 19.6404C20.2896 19.6587 20.2531 19.6678 20.2212 19.6678C20.1437 19.6678 20.0571 19.6154 19.9614 19.5106C19.8657 19.4012 19.7837 19.2736 19.7153 19.1277C19.647 18.9819 19.6128 18.8543 19.6128 18.7449C19.6128 18.549 19.7222 18.3849 19.9409 18.2527C20.1597 18.1206 20.4468 18.0226 20.8023 17.9588C21.1623 17.8904 21.5519 17.8563 21.9712 17.8563C22.4725 17.8563 22.91 17.9429 23.2837 18.116C23.662 18.2892 23.9513 18.5376 24.1519 18.8611C24.3569 19.1802 24.4595 19.5561 24.4595 19.9891C24.4595 20.3992 24.3569 20.7615 24.1519 21.076C23.9513 21.3859 23.6756 21.6137 23.3247 21.7596V21.8074C23.7941 21.9852 24.1473 22.2654 24.3843 22.6483C24.6213 23.0265 24.7398 23.4708 24.7398 23.9813C24.7398 24.5099 24.6235 24.9702 24.3911 25.3621C24.1587 25.7495 23.8351 26.048 23.4204 26.2576C23.0057 26.4627 22.5295 26.5652 21.9917 26.5652ZM26.7495 26.4627C26.5809 26.4627 26.4579 26.424 26.3804 26.3465C26.3029 26.269 26.2642 26.146 26.2642 25.9774V18.4373C26.2642 18.2687 26.3029 18.1479 26.3804 18.075C26.4579 17.9975 26.5809 17.9588 26.7495 17.9588H29.4702C30.3042 17.9588 31.0106 18.1229 31.5894 18.451C32.1727 18.7746 32.6125 19.2531 32.9087 19.8865C33.2095 20.52 33.3599 21.2925 33.3599 22.2039C33.3599 23.1199 33.2095 23.8947 32.9087 24.5281C32.6125 25.1616 32.1727 25.6424 31.5894 25.9705C31.0106 26.2986 30.3042 26.4627 29.4702 26.4627H26.7495ZM29.4702 24.8699C30.1174 24.8699 30.6073 24.6443 30.94 24.1932C31.2726 23.7374 31.439 23.0744 31.439 22.2039C31.439 21.338 31.2726 20.6795 30.94 20.2283C30.6073 19.7726 30.1174 19.5447 29.4702 19.5447H28.1509V24.8699H29.4702Z"
          fill="black"
        />
        <rect
          x="15.0146"
          y="11.5228"
          width="22.7594"
          height="22.7594"
          rx="4"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="5 10"
        />
        <path
          d="M20.9984 1C6.01729 1 3.84482 12.8506 4.63124 18.7759"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.80913 19.0934L1 15.6017"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.12695 18.7759L8.30123 15.6017"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M33.161 47.1387C48.1419 47.0548 50.248 35.1922 49.4284 29.2714"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M49.2485 28.955L53.0771 32.4253"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M48.9334 29.2742L45.7769 32.4662"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
}
